module.exports = __webpack_public_path__ + "static/media/iconTextbookActive.cbedd723.svg";